import { createBrowserRouter, Navigate } from "react-router";

import { PageNotFound } from "@digital-services/shell";
import { PaginationContextProvider } from "@ds-cps/ui";

import Language from "@account/components/Language";
import UserAccountInformation from "@account/components/UserAccountInformation";
import SettingsPage from "@account/pages/SettingsPage";
import { CreateApiUserPage } from "@api-users/pages/CreateApiUserPage";
import { EditApiUserNamePage } from "@api-users/pages/EditApiUserNamePage";
import { EditApiUserPage } from "@api-users/pages/EditApiUserPage";
import { ManageAppRolesPage } from "@api-users/pages/ManageAppRolesPage";
import { RenderApiUsersTab } from "@api-users/part-1-api-user/components/RenderApiUsersTable";
import { ApiSecretsTable } from "@api-users/part-2-api-secrets/components/table/ApiSecretsTable";
import { ApplicationRolesTable } from "@api-users/part-3-app-roles/components/table/ApplicationRolesTable";
import ApplicationPage from "@applications/pages/ApplicationPage";
import OrganizationForm from "@organization/components/organization-info-tab/OrganizationForm";
import { RenderOrganizationUsersTab } from "@organization/components/RenderOrganizationUsersTab";
import OrganizationPage from "@organization/pages/OrganizationPage";
import HomePage from "@pages/HomePage";
import SignedOutPage from "@pages/SignedOutPage";

import { apiUsersFeatureEnabled } from "./feature-flags";
import { Root } from "./root";

const organizationPageTabs = [
  { path: "", element: <OrganizationForm /> },
  {
    // need to show only for Organization Admin users
    path: "users",
    element: <RenderOrganizationUsersTab />
  }
];

if (apiUsersFeatureEnabled) {
  organizationPageTabs.push({
    path: "api-users",
    element: <RenderApiUsersTab />
  });
}

export const router = createBrowserRouter([
  {
    path: "signedout",
    element: <SignedOutPage />
  },
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true, // <-- match on parent, i.e. "/"
        element: <HomePage />
      },
      { path: "/auth-response", element: <Navigate to="/" replace /> },
      {
        path: "organization",
        element: (
          <PaginationContextProvider>
            <OrganizationPage />
          </PaginationContextProvider>
        ),
        children: organizationPageTabs
      },
      {
        path: "organization/create-api-user",
        element: <CreateApiUserPage />
      },
      {
        path: "organization/edit-api-user/:apiUserId",
        element: <EditApiUserPage />,
        children: [
          {
            path: "",
            element: <ApiSecretsTable /> // no <Pagination> needed
          },
          {
            path: "application-roles",
            element: <ApplicationRolesTable />
          }
        ]
      },
      {
        path: "organization/api-user/:apiUserId/manage-application-roles",
        element: <ManageAppRolesPage />
      },
      {
        path: "organization/api-user/:apiUserId/edit-name",
        element: <EditApiUserNamePage />
      },
      { path: "applications", element: <ApplicationPage /> },
      {
        path: "settings",
        element: <SettingsPage />,
        children: [
          { path: "", element: <UserAccountInformation />, index: true },
          { path: "language", element: <Language /> }
        ]
      },

      {
        path: "*",
        element: <PageNotFound />
      }
    ]
  }
]);
